import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import bannerImage from "../../Images/Banner/Gov-body.webp";


// Import all newspaper images
import media1 from "../../Images/media/media 1.webp";
import media2 from "../../Images/media/media 2.webp";
import media3 from "../../Images/media/media 3.webp";
import media4 from "../../Images/media/media 4.webp";
import media5 from "../../Images/media/media 5.webp";
import media6 from "../../Images/media/media 6.webp";
import media7 from "../../Images/media/media 7.webp";
import media8 from "../../Images/media/media 8.webp";
import media9 from "../../Images/media/media 9.webp";
import media10 from "../../Images/media/media 10.webp";
import media11 from "../../Images/media/media 11.webp";
import media12 from "../../Images/media/media 12.webp";
import media13 from "../../Images/media/media 13.webp";
import media14 from "../../Images/media/media 14.webp";
import media16 from "../../Images/media/media 16.webp";
import media15 from "../../Images/media/media 15.webp";
import media17 from "../../Images/media/media 17.webp";
import media18 from "../../Images/media/media 18.webp";
import media19 from "../../Images/media/media 19.webp";
import media20 from "../../Images/media/media 20.webp";
import media21 from "../../Images/media/media 21.webp";
import media22 from "../../Images/media/media 22.webp";
import media23 from "../../Images/media/media 23.webp";
import media24 from "../../Images/media/media 24.webp";
import media25 from "../../Images/media/media 25.webp";
import media26 from "../../Images/media/media 26.webp";
import media27 from "../../Images/media/media 27.webp";
import media28 from "../../Images/media/media 28.webp";
import media29 from "../../Images/media/media 29.webp";
import media30 from "../../Images/media/media 30.webp";
import media31 from "../../Images/media/media 31.webp";
import media33 from "../../Images/media/media 33.webp";
import media34 from "../../Images/media/media 34.webp";
import media35 from "../../Images/media/media 35.webp";
import media36 from "../../Images/media/media 36.webp";
import media37 from "../../Images/media/media 37.webp";
import media38 from "../../Images/media/media 38.webp";
import media39 from "../../Images/media/media 39.webp";
import media40 from "../../Images/media/media 40.webp";
import media41 from "../../Images/media/media 41.webp";
import media42 from "../../Images/media/media 42.webp";
import media43 from "../../Images/media/media 43.webp";
import media44 from "../../Images/events/Month-of-November-2025/WhatsApp Image 2025-11-13 at 2.07.31 PM.jpeg";
import media45 from "../../Images/events/Month-of-November-2025/WhatsApp Image 2025-11-14 at 5.04.10 PM.jpeg";
import media46 from "../../Images/events/Month-of-November-2025/WhatsApp Image 2025-11-15 at 6.24.18 AM.jpeg";
import media47 from "../../Images/events/Month-of-November-2025/WhatsApp Image 2025-11-15 at 6.46.25 AM.jpeg";
import media48 from "../../Images/events/Month-of-November-2025/WhatsApp Image 2025-11-17 at 7.24.41 AM.jpeg";
import media49 from "../../Images/events/Month-of-November-2025/WhatsApp Image 2025-11-16 at 7.08.07 AM.jpeg";
import media50 from "../../Images/events/Month-of-November-2025/WhatsApp Image 2025-11-16 at 7.14.22 AM.jpeg";
import media51 from "../../Images/events/Month-of-November-2025/WhatsApp Image 2025-11-17 at 7.24.42 AM.jpeg";
import media52 from "../../Images/events/Month-of-November-2025/WhatsApp Image 2025-11-17 at 10.03.09 AM.jpeg";
import media53 from "../../Images/media/WhatsApp Image 2025-11-19 at 9.54.46 AM.jpeg";
import media54 from "../../Images/media/WhatsApp Image 2025-11-18 at 11.58.31 AM.jpeg";
import media55 from "../../Images/media/WhatsApp Image 2025-11-18 at 11.58.30 AM.jpeg";
import media56 from "../../Images/media/WhatsApp Image 2025-11-18 at 11.58.30 AM (1).jpeg";
import media57 from "../../Images/media/media 44.jpg";
import media58 from "../../Images/media/media 45.jpg";
import media59 from "../../Images/media/media 46.jpg";
import media60 from "../../Images/media/media 47.jpg";
import media61 from "../../Images/media/media 48.jpg";
import media62 from "../../Images/media/media 49.jpg";
import media63 from "../../Images/media/media 50.jpg";
import media64 from "../../Images/media/media 52.jpg";
import media65 from "../../Images/media/media 53.jpg";
import media66 from "../../Images/media/media 54.webp";
import media67 from "../../Images/media/media 55.webp";
import media68 from "../../Images/media/media 56.webp";
import media69 from "../../Images/media/media 57.webp";
import media70 from "../../Images/media/media 58.webp";
import media71 from "../../Images/media/media 59.jpeg";
import media72 from "../../Images/media/media 60.jpeg";
import media73 from "../../Images/media/media 61.jpeg";
import media74 from "../../Images/media/media 62.webp";
import media75 from "../../Images/media/media 63.webp";
import media76 from "../../Images/media/media 64.webp";
import media77 from "../../Images/media/media 65.webp";
import media79 from "../../Images/media/media 67.jpeg";
import media80 from "../../Images/media/media 68.jpeg";
import media81 from "../../Images/media/media 69.jpeg";
import media82 from "../../Images/media/media 70.jpeg";
import media83 from "../../Images/media/media 71.jpeg";
import media84 from "../../Images/media/media 72.jpeg";
import media85 from "../../Images/media/media 73.jpeg";
import media86 from "../../Images/media/media 74.jpeg";
import media87 from "../../Images/media/media 75.jpeg";
import media88 from "../../Images/media/media 76.jpg";
import media89 from "../../Images/media/media 77.jpeg";
import media90 from "../../Images/media/media 78.png";
import media91 from "../../Images/media/media 79.png";
import media92 from "../../Images/media/media 80.png";
import media93 from "../../Images/media/media 81.png";
import media94 from "../../Images/media/media 82.png";
import media95 from "../../Images/media/media 83.png";
import media96 from "../../Images/media/media 84.png";
import media97 from "../../Images/media/media 85.png";
import media98 from "../../Images/media/media 86.jpeg";
import media99 from "../../Images/media/media 87.png";
import media100 from "../../Images/media/media 88.png";
import media101 from "../../Images/media/media 89.jpeg";
import media102 from "../../Images/media/media 90.jpeg";
import media103 from "../../Images/media/media 91.jpeg";
import media104 from "../../Images/media/media 92.jpeg";
import media105 from "../../Images/media/media 93.jpeg";
import media106 from "../../Images/media/media 94.png";
import media107 from "../../Images/media/media 95.png";
import media108 from "../../Images/media/media 96.png";
import media109 from "../../Images/media/media 97.png";
import media110 from "../../Images/media/media 98.png";
import media111 from "../../Images/media/media 99.png";
import media112 from "../../Images/media/media 100.png";
import media113 from "../../Images/media/media 101.png";
import media114 from "../../Images/media/media 102.png";
import media115 from "../../Images/media/media 103.png";
import media116 from "../../Images/media/media 104.png";
import media117 from "../../Images/media/media 105.png";
import media118 from "../../Images/media/media 106.png";
import media119 from "../../Images/media/media 107.png";
import media120 from "../../Images/media/media 108.png";
import media121 from "../../Images/media/media 109.png";
import media122 from "../../Images/media/media 110.png";
import media123 from "../../Images/media/media 111.png";
import media124 from "../../Images/media/media 112.png";
import media125 from "../../Images/media/media 113.png";
import media126 from "../../Images/media/media 114.png";
import media127 from "../../Images/media/media 115.png";
import media128 from "../../Images/media/media 116.jpeg";
import media129 from "../../Images/media/media 117.jpeg";
import media130 from "../../Images/media/media 118.jpeg";
import media131 from "../../Images/media/media 119.jpeg";
import media132 from "../../Images/media/media 120.jpeg";
import media133 from "../../Images/media/media 121.jpeg";

import pdf1 from "../../Images/media/PDF_06Apr26_0424_splitted (1).pdf";
import cover1 from "../../Images/media/pdf coverpage.png";

import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import "../../Placement.css";

const MediaCoverage = () => {
  const [activeTab, setActiveTab] = useState("media");
  const [selectedMedia, setSelectedMedia] = useState(null);

  const mediaVideos = [
    {
      id: 1,
      url: "https://www.youtube.com/embed/MWLWh0hgGa0",
      title: "Media Coverage of Futsal League",
    },
    {
      id: 2,
      url: "https://www.youtube.com/embed/VO2P-OGklh8",
      title: "Media Coverage of Glibs.in news",
    },
    {
      id: 3,
      url: "https://www.youtube.com/embed/qxvf9KPvKAw",
      title: "Media Coverage of Swaraj Express",
    },
    {
      id: 4,
      url: "https://www.youtube.com/embed/HqxxM7QkteM",
      title: "Media Coverage of Swaraj Express",
    },
    {
      id: 5,
      url: "https://www.youtube.com/embed/jgS_lbVI428",
      title: "Media Coverage of IBC24 News",
    },
    {
      id: 6,
      url: "https://www.youtube.com/embed/490Sw_wiZW8",
      title: "Media Coverage of Desh TV",
    },
    {
      id: 7,
      url: "https://www.youtube.com/embed/d-RIDjYSYFE",
      title: "Media Coverage of Swaraj Express",
    },
    {
      id: 8,
      url: "https://www.youtube.com/embed/d-H0D7OaRp0",
      title: "Media Coverage of Edumate TV",
    },
    {
      id: 9,
      url: "https://www.youtube.com/embed/msaIBvKXjws",
      title: "Media Coverage of IBC24",
    },
  ];

  const newspaperImages = [
    { id: 1, type: "image", src: media1 },
    { id: 2, type: "image", src: media2 },
    { id: 3, type: "image", src: media3 },
    { id: 4, type: "image", src: media4 },
    { id: 5, type: "image", src: media5 },
    { id: 6, type: "image", src: media6 },
    { id: 7, type: "image", src: media7 },
    { id: 8, type: "image", src: media8 },
    { id: 9, type: "image", src: media9 },
    { id: 10, type: "image", src: media10 },
    { id: 11, type: "image", src: media11 },
    { id: 12, type: "image", src: media12 },
    { id: 13, type: "image", src: media13 },
    { id: 14, type: "image", src: media14 },
    { id: 15, type: "image", src: media15 },
    { id: 16, type: "image", src: media16 },
    { id: 17, type: "image", src: media17 },
    { id: 18, type: "image", src: media18 },
    { id: 19, type: "image", src: media19 },
    { id: 20, type: "image", src: media20 },
    { id: 21, type: "image", src: media21 },
    { id: 22, type: "image", src: media22 },
    { id: 23, type: "image", src: media23 },
    { id: 24, type: "image", src: media24 },
    { id: 25, type: "image", src: media25 },
    { id: 26, type: "image", src: media26 },
    { id: 27, type: "image", src: media27 },
    { id: 28, type: "image", src: media28 },
    { id: 29, type: "image", src: media29 },
    { id: 30, type: "image", src: media30 },
    { id: 31, type: "image", src: media31 },
    { id: 33, type: "image", src: media33 },
    { id: 34, type: "image", src: media34 },
    { id: 35, type: "image", src: media35 },
    { id: 36, type: "image", src: media36 },
    { id: 37, type: "image", src: media37 },
    { id: 38, type: "image", src: media38 },
    { id: 39, type: "image", src: media39 },
    { id: 40, type: "image", src: media40 },
    { id: 41, type: "image", src: media41 },
    { id: 42, type: "image", src: media42 },
    { id: 43, type: "image", src: media43 },
    { id: 44, type: "image", src: media44 },
    { id: 45, type: "image", src: media45 },
    { id: 46, type: "image", src: media46 },
    { id: 47, type: "image", src: media47 },
    { id: 48, type: "image", src: media48 },
    { id: 49, type: "image", src: media49 },
    { id: 50, type: "image", src: media50 },
    { id: 51, type: "image", src: media51 },
    { id: 52, type: "image", src: media52 },
    { id: 53, type: "image", src: media53 },
    { id: 54, type: "image", src: media54 },
    { id: 55, type: "image", src: media55 },
    { id: 56, type: "image", src: media56 },
    { id: 57, type: "image", src: media57 },
    { id: 58, type: "image", src: media58 },
    { id: 59, type: "image", src: media59 },
    { id: 60, type: "image", src: media60 },
    { id: 61, type: "image", src: media61 },
    { id: 62, type: "image", src: media62 },
    { id: 63, type: "image", src: media63 },
    { id: 64, type: "image", src: media64 },
    { id: 65, type: "image", src: media65 },
    { id: 66, type: "image", src: media66 },
    { id: 67, type: "image", src: media67 },
    { id: 68, type: "image", src: media68 },
    { id: 69, type: "image", src: media69 },
    { id: 70, type: "image", src: media70 },
    { id: 71, type: "image", src: media71 },
    { id: 72, type: "image", src: media72 },
    { id: 73, type: "image", src: media73 },
    { id: 74, type: "image", src: media74 },
    { id: 75, type: "image", src: media75 },
    { id: 76, type: "image", src: media76 },
    { id: 77, type: "image", src: media77 },
    { id: 79, type: "image", src: media79 },
    { id: 80, type: "image", src: media80 },
    { id: 81, type: "image", src: media81 },
    { id: 82, type: "image", src: media82 },
    { id: 83, type: "image", src: media83 },
    { id: 84, type: "image", src: media84 },
    { id: 85, type: "image", src: media85 },
    { id: 86, type: "image", src: media86 },
    { id: 87, type: "image", src: media87 },
    { id: 88, type: "image", src: media88 },
    { id: 89, type: "image", src: media89 },
    { id: 90, type: "image", src: media90 },
    { id: 91, type: "image", src: media91 },
    { id: 92, type: "image", src: media92 },
    { id: 93, type: "image", src: media93 },
    { id: 94, type: "image", src: media94 },
    { id: 95, type: "image", src: media95 },
    { id: 96, type: "image", src: media96 },
    { id: 97, type: "image", src: media97 },
    { id: 98, type: "image", src: media98 },
    { id: 99, type: "image", src: media99 },
    { id: 100, type: "image", src: media100 },
    { id: 101, type: "image", src: media101 },
    { id: 102, type: "image", src: media102 },
    { id: 103, type: "image", src: media103 },
    { id: 104, type: "image", src: media104 },
    { id: 105, type: "image", src: media105 },
    { id: 106, type: "image", src: media106 },
    { id: 107, type: "image", src: media107 },
    { id: 108, type: "image", src: media108 },
    { id: 109, type: "image", src: media109 },
    { id: 110, type: "image", src: media110 },
    { id: 111, type: "image", src: media111 },
    { id: 112, type: "image", src: media112 },
    { id: 113, type: "image", src: media113 },
    { id: 114, type: "image", src: media114 },
    { id: 115, type: "image", src: media115 },
    { id: 116, type: "image", src: media116 },
    { id: 117, type: "image", src: media117 },
    { id: 118, type: "image", src: media118 },
    { id: 119, type: "image", src: media119 },
    { id: 120, type: "image", src: media120 },
    { id: 121, type: "image", src: media121 },
    { id: 122, type: "image", src: media122 },
    { id: 123, type: "image", src: media123 },
    { id: 124, type: "image", src: media124 },
    { id: 125, type: "image", src: media125 },
    { id: 126, type: "image", src: media126 },
    { id: 127, type: "image", src: media127 },
    { id: 128, type: "image", src: media128 },
    { id: 129, type: "image", src: media129 },
    { id: 130, type: "image", src: media130 },
    { id: 131, type: "image", src: media131 },
    { id: 132, type: "image", src: media132 },
    { id: 133, type: "image", src: media133 },
    { id: 134, type: "pdf", src: pdf1, cover: cover1 },
  ].sort((a, b) => b.id - a.id);

  return (
    <>
      <title>
        ISBM University Media Coverage | News, Events & Achievements
      </title>
      <meta
        name="description"
        content="Discover ISBM University's media presence, featuring news highlights, achievements, and milestones shaping the future of education."
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="conatiner-xxl">
            <div className="section-hero-content">
              <h1>Media reflects and builds reputation</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                    Home
                  </a>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Media Coverage
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="media-section ptb-50">
        <div className="container-xxl">
          <div className="row m-0">
            <div className="row mb-5">
              <div className="col-6">
                <div className="media-tabs shadow-lg">
                  <div
                    className={`media-tab ${activeTab === "media" ? "active" : ""}`}
                    onClick={() => setActiveTab("media")}
                  >
                    <div className="tab-icon">
                      <i className="fa fa-video-camera" aria-hidden="true"></i>
                    </div>
                    <div className="tab-content">
                      <h2>Media Coverage</h2>
                      <p>Video news clips and interviews</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="media-tabs shadow-lg">
                  <div
                    className={`media-tab ${activeTab === "newspaper" ? "active" : ""}`}
                    onClick={() => setActiveTab("newspaper")}
                  >
                    <div className="tab-icon">
                      <i className="fa fa-newspaper-o" aria-hidden="true"></i>
                    </div>
                    <div className="tab-content">
                      <h2>Newspaper Coverage</h2>
                      <p>Articles and press coverage</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12">
              <div className="media-tab-content">
                {activeTab === "media" && (
                  <div className="tab-pane active">
                    <div className="media-card">
                      <div className="tab-section-body">
                        <div className="row m-0">
                          {mediaVideos.map((video) => (
                            <div className="pb-4 col-lg-3" key={video.id}>
                              <div className="card rounded-2 h-100 shadow-lg border-0">
                                <div className="ratio ratio-16x9 p-1">
                                  <iframe
                                    src={video.url}
                                    title={video.title}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                  ></iframe>
                                </div>
                                <div className="card-body">
                                  <h6 className="card-title text-blue fw-bold text-center mb-0">
                                    {video.title}
                                  </h6>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === "newspaper" && (
                  <div className="tab-pane active">
                    <div className="media-card">
                      <div className="tab-section-body">
                        <div className="row m-0">
                          {newspaperImages.map((item) => (
                            <div
                              className="pb-4 col-lg-3 col-md-4 col-6 mt-3"
                              key={item.id}
                            >
                              <img
                                src={
                                  item.type === "image" ? item.src : item.cover
                                }
                                alt="media"
                                style={{
                                  width: "100%",
                                  height: "250px",
                                  objectFit: "cover",
                                  cursor: "pointer",
                                  border: "4px solid #001e62",
                                  borderRadius: "8px",
                                }}
                                onClick={() => setSelectedMedia(item)}
                              />

                              {item.type === "pdf" && (
                                <div className="text-center text-danger fw-bold mt-1">
                                  PDF
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Image Modal */}
      {selectedMedia && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-xl modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {selectedMedia.type === "image"
                    ? "Newspaper Image"
                    : "PDF Viewer"}
                </h5>
                <button
                  className="btn-close"
                  onClick={() => setSelectedMedia(null)}
                ></button>
              </div>

              <div
                className="modal-body text-center"
                style={{
                  height: selectedMedia.type === "pdf" ? "80vh" : "auto",
                }}
              >
                {selectedMedia.type === "image" ? (
                  <img
                    src={selectedMedia.src}
                    alt="media"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "80vh",
                      border: "5px solid #001e62",
                      borderRadius: "8px",
                    }}
                  />
                ) : (
                  <iframe
                    src={selectedMedia.src}
                    title="PDF Viewer"
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "none",
                    }}
                  />
                )}
              </div>

              {selectedMedia.type === "pdf" && (
                <div className="modal-footer">
                  <a
                    href={selectedMedia.src}
                    download
                    className="btn btn-primary"
                  >
                    Download PDF
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default MediaCoverage;
